const data = {
	"categories": {
			"Foods" : [
				{
					"id": 1,
					"name": "Broccoli",
					"category": "Cruciferous Superfood",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697524/MyCustomAppFolder/Broccoli_lavuwu.jpg",
					"text": "Broccoli contains Sulforaphane that has been shown to have anticancer properties and may prevent cancer cell growth by releasing antioxidant and detoxification enzymes that protect against carcinogens — substances that cause cancer "
				},
				{
					"id": 2,
					"name": "Leafy Greens",
					"category": "Must To Include in Daily Diet",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697792/MyCustomAppFolder/LeafyGreens_j3xxc1.jpg",
					"text": "Dark, leafy greens are a good source of vitamin A, vitamin C, fiber and calcium, as well as several phytochemicals."
				},
				{
					"id": 3,
					"name": "Plums",
					"category": "A Stone Fruit",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697836/MyCustomAppFolder/Plums_gjhkop.webp",
					"text": "Rich in hydroxycinnamic acids, a type of polyphenol antioxidant, Plums reduce cellular damage caused by unstable free radicals, which reduces risk of diseases. Plums are also rich in vitamin-C and provitamin-A carotenoids, both of which have antioxidant and anti-inflammatory properties"
				},
				{
					"id": 4,
					"name": "Blueberries",
					"category": "Sweet Disease Fighters",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697838/MyCustomAppFolder/Blueberries_dprgp4.jpg",
					"text": "Blueberries contain potent antioxidants and are rich in anthocyanins, which are plant pigments that account for up to 60% of their total polyphenol compounds. Consuming blueberries has been linked to a reduced risk of heart disease and type 2 diabetes."
				},
				{
					"id": 5,
					"name": "Yogurt",
					"category": "Probiotics",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697836/MyCustomAppFolder/Yogurt_xnuysy.jpg",
					"text": "A good source of calcium and protein, yogurt contains live cultures called probiotics. These 'good bacteria' protects the body from other harmful bacteria."
				}
			],
			
			"Exercises" : [
				{
					"id": 6,
					"name": "Brisk Walking",
					"category": "Moderate Intensity Aerobic Activity",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697938/MyCustomAppFolder/BriskWalking_qphgai.jpg",
					"text": "Brisk Walking benefits include reducing risk of heart disease, diabetes, and certain cancers, such as bladder, breast, and colon cancer.Additionally, a 2014 study concluded that a twice-weekly 6-month outdoor brisk walking program increased hippocampus volume in older females who were likely to have mild cognitive impairment."
				},
				{
					"id": 7,
					"name": "Push-ups and Weight Resistance",
					"category": "Intense Cardio Activity",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697938/MyCustomAppFolder/IntenseWorkout_xmm21t.jpg",
					"text": "Push ups benefit your cardiovascular health by pumping enough blood and oxygen throughout your body. Keeps your heart strong and lowers the risk of cardiovascular problems—including heart attack and heart failure. The benefits also include the reduction of stored body fat."
				},
				{
					"id": 8,
					"name": "Yoga",
					"category": "Light to Moderate Intensity Activity",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697938/MyCustomAppFolder/Yoga_sx3u6o.jpg",
					"text": "Yoga reduces inflammation - the precursor to chronic illness. One review examined 15 research studies and found a common result: Yoga — of various intensities and durations — reduced the biochemical markers of inflammation across several chronic conditions "
				},
				{
					"id": 9,
					"name": "Swimming",
					"category": "Complete body workout for all age groups",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687697939/MyCustomAppFolder/Swimming_fvdkku.jpg",
					"text": "Swimming is an ideal workout not only for youger age groups but even for the elderly, mainly because it presents little risk of injury and is low impact. Water exercises work out all the muscle groups in the body, presenting a complete workout for seniors."
				}
			],
			
			"Mental Health":[
				{
					"id": 10,
					"name": "Listening Music",
					"category": "Pursue Music as a hobby",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698014/MyCustomAppFolder/Music_gl1303.jpg",
					"text": "Music serves as a distraction from the symptoms of mental health issues,”. In fact, research has shown that music can lessen the impact of depression and anxiety."
				},
				
				{
					"id": 11,
					"name": "Meditation",
					"category": "Workout for your mind to help you stay centered & focused",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698014/MyCustomAppFolder/meditation_nqjakb.jpg",
					"text": "Meditation can give you a sense of calm, peace and balance that can benefit both your emotional well-being and your overall health. You can use it to relax and cope with stress by refocusing your attention on something calming."
					
				},
				
				{
					"id": 12,
					"name": "Cognitive Behavioral Sessions",
					"category": "Therapy",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698014/MyCustomAppFolder/CBT_sfpslj.jpg",
					"text": "Cognitive behavioral therapy (CBT) is a structured, goal-oriented talk therapy. It can help manage mental health conditions. CBT also helps manage nonpsychological health conditions, such as insomnia and chronic pain."
				},
				
				{
					"id": 13,
					"name": "Doctor Consultations",
					"category": "Counseling",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698014/MyCustomAppFolder/Counseling_fogalk.jpg",
					"text": "Often consultations are avoided due to the social stigma associated with mental health, but the truth is, counseling help individuals overcome previous trauma or mental and emotional roadblocks so they can reduce stress and anxiety, avoid emotional triggers, form healthy relationships, increase work productivity and take other positive initiatives."
				}
			],
			
			"Health Checkups":[
				{
					"id": 14,
					"name": "Regular Tooth Scaling",
					"category": "Dental Checkups",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698107/MyCustomAppFolder/Dental_s16y5r.webp",
					"text": "Scaling eliminates tartar and plaque to keep teeth and gums healthy and free of bacteria. It also prevents bad breath and bleeding gums. Therefore, scaling is advantageous, and people should visit a dental clinics regularly for doing it."
				},
				
				{
					"id": 15,
					"name": "Blood Tests",
					"category": "Full Body Checkups",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698107/MyCustomAppFolder/BloodTest_ktwbwp.jpg",
					"text": "Regular Blood tests help doctors check for certain diseases and conditions. They also help check the function of your organs and show how well treatments are working."
				},
				
				{
					"id": 16,
					"name": "Calcium Score Test(HEART SCAN)",
					"category": "Cardiovascular Health Checkup",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698268/MyCustomAppFolder/CardiovascularCheckups_mwjqkr.jpg",
					"text": "Determining your calcium score is very useful. A Heart Scan Test Detects calcium deposits in the coronary arteries to predict the likelihood of a future heart attack or stroke."
				},
				
				{
					"id": 17,
					"name": "Ultrasound",
					"category": "Image Test Checkup",
					"image": "https://res.cloudinary.com/dqsmnuwjy/image/upload/v1687698107/MyCustomAppFolder/Ultrasound_h5yzfs.jpg",
					"text": "Ultrasound can help determine the cause of stomach pain, help check for kidney stones, liver disease, tumors and many other conditions. "
				}
			]
		}
}

export default data.categories;